'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cc = require('classcat');
var reactTransitionGroup = require('react-transition-group');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cc__default = /*#__PURE__*/_interopDefaultLegacy(cc);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".react-modal_2-0-2_co-modal,\n.react-modal_2-0-2_co-modal__dialog,\n.react-modal_2-0-2_co-modal__overlay {\n  box-sizing: border-box;\n}\n\n.react-modal_2-0-2_co-modal {\n  --dialog-max-width: 90%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  visibility: hidden;\n  opacity: 0;\n}\n\n.react-modal_2-0-2_co-modal,\n.react-modal_2-0-2_co-modal__overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.react-modal_2-0-2_co-modal__overlay {\n  background-color: var(--gray-900);\n  opacity: 0.5;\n}\n\n.react-modal_2-0-2_co-modal__container {\n  z-index: 1;\n  width: var(--dialog-width);\n  max-width: var(--dialog-max-width);\n}\n\n.react-modal_2-0-2_co-modal__dialog {\n  display: flex;\n  flex-direction: column;\n  min-height: var(--dialog-min-height);\n  max-height: calc(100vh - 100px);\n  border-radius: 4px;\n  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0px rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.2);\n  background-color: var(--white);\n}\n\n.react-modal_2-0-2_co-modal.react-modal_2-0-2_co-modal--small {\n  --dialog-width: 405px;\n  --dialog-min-height: 250px;\n}\n.react-modal_2-0-2_co-modal.react-modal_2-0-2_co-modal--medium, .react-modal_2-0-2_co-modal {\n  --dialog-width: 600px;\n  --dialog-min-height: 375px;\n}\n.react-modal_2-0-2_co-modal.react-modal_2-0-2_co-modal--large {\n  --dialog-width: calc(100% - 32px);\n  --dialog-max-width: 900px;\n  --dialog-min-height: 500px;\n}\n.react-modal_2-0-2_co-modal.react-modal_2-0-2_co-modal--visible, .react-modal_2-0-2_co-modal[data-transition=entering], .react-modal_2-0-2_co-modal[data-transition=entered] {\n  opacity: 1;\n  visibility: visible;\n}\n.react-modal_2-0-2_co-modal[data-transition=exiting] {\n  opacity: 0;\n  visibility: visible;\n}\n.react-modal_2-0-2_co-modal[data-transition=exited] {\n  opacity: 0;\n  visibility: hidden;\n}";
var styles = {
  "co-modal": "react-modal_2-0-2_co-modal",
  "co-modal__dialog": "react-modal_2-0-2_co-modal__dialog",
  "co-modal__overlay": "react-modal_2-0-2_co-modal__overlay",
  "co-modal__container": "react-modal_2-0-2_co-modal__container",
  "co-modal--small": "react-modal_2-0-2_co-modal--small",
  "co-modal--medium": "react-modal_2-0-2_co-modal--medium",
  "co-modal--large": "react-modal_2-0-2_co-modal--large",
  "co-modal--visible": "react-modal_2-0-2_co-modal--visible"
};
styleInject(css);

const duration = 500;
const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`
};

const getTransitionAttributes = status => ({
  "data-transition": status
});

const getClassName = modifier => modifier ? `co-modal--${modifier}` : "";

const Modal = ({
  className = "",
  forwardedRef,
  size = "medium",
  visible,
  children,
  ...props
}) => {
  const classStyles = [styles["co-modal"], styles[getClassName(size)], className];
  return /*#__PURE__*/React__default['default'].createElement(reactTransitionGroup.Transition, {
    in: visible,
    timeout: duration
  }, status => /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cc__default['default'](classStyles),
    ref: forwardedRef,
    style: { ...defaultStyle,
      ...props.style
    }
  }, props, getTransitionAttributes(status), {
    "data-co-name": "Modal",
    "data-co-version": "2.0.2",
    "data-co-project": "cobalt"
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles["co-modal__overlay"]
  }), status !== "exited" && /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles["co-modal__container"]
  }, children)));
};

const ModalDialog = ({
  className = "",
  forwardedRef,
  ...props
}) => {
  const classStyles = [styles["co-modal__dialog"], className];
  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cc__default['default'](classStyles),
    ref: forwardedRef
  }, props));
};

exports.Dialog = ModalDialog;
exports.default = Modal;
